<template>
    <div class="md-layout-item">
        <h4>Options</h4>
        <draggable v-model="options_list" group="radios" @end="saveOption" handle=".handle">
            <div v-bind:key="index" v-for="(option, index) in options_list" >
                <md-divider></md-divider>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-10 handle">
                        <md-icon>reorder</md-icon>
                    </div>
                    <div class="md-layout-item md-size-10">
                        <md-checkbox v-model="option.checked"></md-checkbox>
                    </div>
                    <div class="md-layout-item">
                    <md-field>
                            <label>Label</label>
                            <md-input v-model="option.label"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>Value</label>
                            <md-input v-model="option.value"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-button @click="removeOption(index)">Remove</md-button>
                    </div>
                </div>
            </div>
        </draggable>
        <md-button class="md-raised md-primary" @click="addOption">Add Option</md-button>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "FbCheckboxOption",
  props: ["options"],
  components: {
    draggable,
  },
  data() {
    return {
      options_list: this.options,
    };
  },
  methods: {
    addOption() {
      this.options_list.push({
        checked: false,
        label: "",
        value: "",
      });
    },
    removeOption(index) {
      this.options_list.splice(index, 1);
    },
    saveOption() {
      this.$emit("save-option", this.options_list);
    },
  },
};
</script>